import React from 'react';
import {
  STATIC_CONTENT_PROPERTY_DETAIL_TYPE,
  StaticContentImage,
  StaticContentProperty,
  StaticContentText,
} from 'shared';
import { FormFieldProps } from '../shared';

type Props = FormFieldProps<StaticContentProperty>;

export const StaticContent: React.FC<Props> = ({
  property,
  design,
  className,
}) => {
  switch (property.detail.staticContentType) {
    case STATIC_CONTENT_PROPERTY_DETAIL_TYPE.text:
      return (
        <StaticContentText
          propertyId={property.propertyId}
          text={property.detail.text}
          color={design.colors.messageFont}
          className={className}
        />
      );
    case STATIC_CONTENT_PROPERTY_DETAIL_TYPE.image:
      return (
        <StaticContentImage
          propertyId={property.propertyId}
          url={property.detail.url}
          alt={property.detail.alt}
          position={property.detail.position}
          className={className}
        />
      );
  }
};
